
import { Vue, Component } from 'vue-property-decorator';
import HeaderLogo from '../components/Layout/HeaderLogo.vue';
import ResponsiveContainer from '../components/Layout/ResponsiveContainer.vue';
import { AvailableLoan } from '@/interfaces/loan';
import LoanItem from '@/components/MultiLoan/LoanItem.vue';
import { clearStorage } from '@/storage';

@Component({
  components: { ResponsiveContainer, HeaderLogo, LoanItem }
})
export default class SelectLoan extends Vue {
  get availableLoans(): AvailableLoan[] {
    return this.$store.getters['User/availableLoans'];
  }

  setActiveLoan(loan: AvailableLoan) {
    this.$store.dispatch('User/setActiveLoan', loan.loan_number);
    this.$router.push({ name: 'home' });
  }

  logout() {
    clearStorage();
    window.location.reload();
  }
}
